import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { API_ROOT } from "../../../utils/api-config";

export const billApi = createApi({
  reducerPath: "billApi",
  baseQuery: fetchBaseQuery({
    baseUrl: API_ROOT,
    prepareHeaders: (headers, { getState }) => {
      const token = getState().auth.currentAgent.access_token;
      headers.set("Authorization", `Bearer ${token}`);
      return headers;
    },
  }),
  tagTypes: ["Bill"],
  endpoints: (builder) => ({
    billFees: builder.mutation({
      query: (payload) => ({
        url: "/api/frais/",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["Bill"],
    }),

    // FAARF
    billFaarfGet: builder.mutation({
      query: (payload) => ({
        url: "/api/faarf/get/",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["Bill"],
    }),

    billFaarfPay: builder.mutation({
      query: (payload) => ({
        url: "/api/faarf/pay/",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["Bill"],
    }),

    // DGID
    billDGIDGet: builder.mutation({
      query: (payload) => ({
        url: "/api/orbus/get/",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["Bill"],
    }),

    billDGIDPay: builder.mutation({
      query: (payload) => ({
        url: "/api/orbus/pay/",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["Bill"],
    }),

    // SAAR
    billSAARGet: builder.mutation({
      query: (payload) => ({
        url: "/api/saar/get/",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["Bill"],
    }),

    billSAARPay: builder.mutation({
      query: (payload) => ({
        url: "/api/saar/pay/",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["Bill"],
    }),

    // AGRIVOUCHER
    billAgriVoucherGet: builder.mutation({
      query: (payload) => ({
        url: "/api/v1/agrivoucher/get/",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["Bill"],
    }),

    billAgriVoucherPay: builder.mutation({
      query: (payload) => ({
        url: "/api/v1/agrivoucher/pay/",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["Bill"],
    }),

    billAgriVoucherEnlevement: builder.mutation({
      query: (payload) => ({
        url: "/api/v1/agrivoucher/pickup/",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["Bill"],
    }),

    // STARTIME
    billStartimeGet: builder.mutation({
      query: (payload) => ({
        url: "/v1/niirpay/retrieve/",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["Bill"],
    }),

    billStartimePay: builder.mutation({
      query: (payload) => ({
        url: "/v1/niirpay/payment/",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["Bill"],
    }),

    // ONEA
    billOneaGet: builder.mutation({
      query: (payload) => ({
        url: "/api/v1/onea/get/",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["Bill"],
    }),

    billOneaPay: builder.mutation({
      query: (payload) => ({
        url: "/api/v1/onea/payment/",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["Bill"],
    }),

    // WOYOFAL
    billWoyofalGet: builder.mutation({
      query: (payload) => ({
        url: "/api/v2/woyofal/simulation/",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["Bill"],
    }),

    billWoyofalReload: builder.mutation({
      query: (payload) => ({
        url: "/api/v2/woyofal/reload/",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["Bill"],
    }),

    // SAAR
    billSaarGetCouverture: builder.mutation({
      query: (payload) => ({
        url: "/api/v2/saar/couvertures/",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["Bill"],
    }),

    billSaarGetVehicules: builder.mutation({
      query: (payload) => ({
        url: "/api/v2/saar/vehicules/",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["Bill"],
    }),

    billSaarGetCategories: builder.mutation({
      query: (payload) => ({
        url: "/api/v2/saar/categories/",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["Bill"],
    }),

    billSaarGetPacksPrivilege: builder.mutation({
      query: (payload) => ({
        url: "/api/v2/saar/packs_privilege/",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["Bill"],
    }),

    billSaarGetPacks: builder.mutation({
      query: (payload) => ({
        url: "/api/v2/saar/packs_privilege/",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["Bill"],
    }),

    billSaarSimulation: builder.mutation({
      query: (payload) => ({
        url: "/api/v2/saar/simulation/pay/",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["Bill"],
    }),

    billSaarPay: builder.mutation({
      query: (payload) => ({
        url: "/api/v2/saar/pay/",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["Bill"],
    }),

    // RECHARGE CARTE
    billCardGet: builder.mutation({
      query: (payload) => ({
        url: "/api/gtp/card/list/",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["Bill"],
    }),

    billCardReload: builder.mutation({
      query: (payload) => ({
        url: "/api/gtp/card/w2c/",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["Bill"],
    }),

    // BALOON ASSURANCE
    billBaloonSimulation: builder.mutation({
      query: (payload) => ({
        url: "/api/baloon/simulation/",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["Bill"],
    }),

    billBaloonInputProcess: builder.mutation({
      query: (payload) => ({
        url: "/api/baloon/input_process/next_page/",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["Bill"],
    }),

    billBaloonInputSave: builder.mutation({
      query: (payload) => ({
        url: `/api/baloon/input_process/save_or_update/?simulation_id=${payload.simulation_id}&page_code=${payload.page_code}&risk_id=1&step=NimbaAutoSN02&operation=savepage`,
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["Bill"],
    }),


    billBaloonPricingRequest: builder.mutation({
      query: (payload) => ({
        url: "/api/baloon/pricing/request/",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["Bill"],
    }),
  }),
});

export const {
  useBillFeesMutation,
  useBillFaarfGetMutation,
  useBillFaarfPayMutation,
  useBillDGIDGetMutation,
  useBillDGIDPayMutation,
  useBillSAARGetMutation,
  useBillAgriVoucherGetMutation,
  useBillAgriVoucherPayMutation,
  useBillAgriVoucherEnlevementMutation,
  useBillStartimeGetMutation,
  useBillStartimePayMutation,
  useBillOneaGetMutation,
  useBillOneaPayMutation,
  useBillWoyofalGetMutation,
  useBillWoyofalReloadMutation,
  useBillSaarGetCategoriesMutation,
  useBillSaarGetCouvertureMutation,
  useBillSaarGetPacksMutation,
  useBillSaarGetVehiculesMutation,
  useBillSaarPayMutation,
  useBillSaarSimulationMutation,
  useBillSaarGetPacksPrivilegeMutation,
  useBillCardGetMutation,
  useBillCardReloadMutation,
  useBillBaloonSimulationMutation,
  useBillBaloonInputProcessMutation,
  useBillBaloonInputSaveMutation,
  useBillBaloonPricingRequestMutation
} = billApi;
